/*
 * Copyright (c) 2019.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

export interface SupplierImportLog {
  id?: number;
  name: string;
  header: string;
  isSystem?: boolean;
  deleted?: boolean;
}

/**
 * Запись лога прогона импорта (эндпоинт `/get-last-imports`). Отдельный тип от
 * `SupplierImportLog` (тот — метаданные шаблона): консьюмеры (supplier-import-template,
 * marketplace-export-template) читают только эти поля. Строгий `@for` обнажил, что раньше
 * тип лога отсутствовал и нестрогий `*ngFor` это глотал.
 */
export interface SupplierImportRunLog {
  id?: number;
  createdAt: string;
  numberOfRows: number;
  count: number;
  status: string;
  documentId: number;
  /** Документ ПРОГОНА (CORE `SupplierImportLogDto.document`) — его fileName даёт расширение скачиваемого файла. */
  document?: { fileName?: string; mimeType?: string } | null;
  /**
   * AOIS-20 BUILD-2: manual/email/directory — merged in client-side from
   * `/supplier-import-template/{id}/log-import-source` (CORE's own log-list response is
   * JPA-entity based and cannot serialize this demo-added column). Absent until that merge runs.
   */
  importSource?: string;
  /**
   * AOIS-perf (row-truth fix). Client-merged from a sibling demo endpoint (`/{id}/log-row-counts`) —
   * CORE's `get-last-imports/plain` only carries `count` (unique-product count) and a legacy
   * `numberOfRows` demo never populates; neither is a real file-row count. `totalRows` — exact file-data
   * row precount; `processedRows` — `totalRows` minus distinct error rows. `null`/absent (before the
   * merge resolves, or when the source file is gone) renders as "—", never a product-count.
   */
  totalRows?: number | null;
  processedRows?: number | null;
}

/** Per-log row counts from `GET /supplier-import-template/{templateId}/log-row-counts`, keyed by logId. */
export interface SupplierImportLogRowCounts {
  totalRows: number | null;
  processedRows: number | null;
}
